import React, { useRef, useState } from "react";
import { Container, Grid, useTheme } from "@mui/material";

import { P, SectionHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";

import buy from "../../../assets/images/buy.png"
import wallet from "../../../assets/images/wallet.png"
import earn from "../../../assets/images/earn.png"
import reflec from "../../../assets/images/reflec.png"
import { TWrapper, Name, Value, MainGrid, Textarea, ContractAdd } from "./styles";
import styled from "@emotion/styled";
import up from "../../../assets/images/arbbackground.png"
const MainWrapper = styled.div`
background-image: url(${up});
background-size: cover;
display:flex;
align-items: center;
min-height: 100vh;
padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`

const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 8px 50px;
border-radius: 5px;
margin-right: 15px;

`

const Img = styled.img`
  /* width:100%;
  max-width: 50px; */
`
const RefelcImg = styled.img`
position:absolute;
left: 50px;
@media screen and (max-width:499px) {
  left: 20px;
  
}
`
const GridsWrap = styled(Grid)`
  padding-left: 133px;
  @media screen and (max-width:599px) {
    padding-left: 110px;
  
}
`
const Containers = styled(Container)`
  position: relative;
`
const Index = () => {
  const theme = useTheme()

  return (
    <MainWrapper align="left" p599="14rem 0px" p="14rem 0 10rem" id="arbreflection" data-aos="fade-up"
    data-aos-anchor-placement="center-bottom"  data-aos-delay="400"
    data-aos-duration="1000">
      <Containers maxWidth="xl">
        <RefelcImg src={reflec}/>
      <MainGrid container spacing={0}>
          <GridsWrap item xs={12} md={6} data-aos="fade-up"
     data-aos-anchor-placement="top-bottom" data-aos-delay="600"
     data-aos-duration="1000">
              <SectionSubHeading p399="60px 0 0" p="50px 0 0px" p599="80px 0 0px">
              Buy $Arbflow
              </SectionSubHeading>
          <P p="0px 0 50px" m="0" maxWidth="70%"  fs600px="14px">Buy $ArbFlow using your Ethereum DEX of choice</P>
              {/* <Img src={wallet}/> */}
              <SectionSubHeading fs599="20px" p599="80px 0 0px" p399="100px 0 0" p="100px 0 0px" m="0">
              Hold In Wallet
              </SectionSubHeading>
          <P p="0px 0 50px" m="0" maxWidth="70%" fs600px="14px" >Your purchased $ArbFlow tokens should be displayed in your wallet</P>
              {/* <Img src={earn}/> */}
              <SectionSubHeading p399="80px 0 0" p="100px 0 0px" p599="120px 0 0px" >
              Earn $ARB
              </SectionSubHeading>
          <P p="0px 0 50px" m="0" maxWidth="70%"  fs600px="14px">You're all set for $ARB tokens will be airdropped to your wallet in regular intervals!</P>
          </GridsWrap>
          <Grid item xs={12} md={6}>
          <SectionHeading p="20px 0px" m="0"  data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="500"
            data-aos-duration="700"
            data-aos-offset="0">$ARB Reflection</SectionHeading>
          <P maxWidth="75%" p="0px 0 30px" m="0"  data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="600"
            data-aos-duration="700"
            data-aos-offset="0">ArbFlow rewards holders with Arbitrum coins, which are automatically distributed to eligible holders. The more tokens you hold, the more Arbitrum coins you earn. Our tokenomics model is designed to provide a steady and passive source of income for our holders, while also ensuring the stability and growth of the platform.</P>
      
       <BuyNow href="https://arbflow.medium.com/" target="blank" bgColor={theme.textPrimary} Color={theme.textTertiary} data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="700"
            data-aos-duration="700"
            data-aos-offset="0">Read More</BuyNow>
        </Grid>
        </MainGrid>
      </Containers>
    </MainWrapper>
  );
};

export default Index;
